import { env } from '@/config/env'

/** Platform minimum redemption amount (USD) — from `VITE_MIN_REDEEM_USD`. */
export const minRedeemUsd = env.VITE_MIN_REDEEM_USD

/** When true, platform minimum gates are bypassed; only brand rules apply. */
export const isMinRedeemBypassed = minRedeemUsd === 0

export function resolveEffectiveMinUsd(brandMinUsd: number): number {
  return isMinRedeemBypassed ? brandMinUsd : Math.max(minRedeemUsd, brandMinUsd)
}

export function formatMinRedeemUsd(): string {
  return `$${minRedeemUsd.toFixed(2)}`
}
